module.exports = __webpack_public_path__ + "9cc85a0bddfa07a28398d6f825cca0a9.pdf";